export default {
  RANGE: 'range',
  SINGLE: 'single'
};
